import React, { Component } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { compose } from "redux";
import { createHashHistory } from "history";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert,
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../components";
import {
  addInvoices,
  getInvoicesDetails,
  updateInvoices,
  getSiteList,
  get_site_details_id,
} from "../../redux/actions/invoicesActions";
import "../../style/invoices/invoicesDetails.scss";
import moment from "moment";
import isEmpty from "lodash.isempty";
const history = createHashHistory();

let isLoading = "false";
const siteLogo =
  "https://d266oi3blg1w2v.cloudfront.net/designCenter/jOQfA7F3VcmLDEuz3VLoajjzc72pLvE5N7GnhD5U.png";

class InvoicesDetails extends Component {
  constructor(props) {
    const viewLink =
      props.match &&
      props.match.params &&
      `InvoicesDetails/${props.match.params.invoicesId}`;
    super(props);
    this.state = {
      path: ["Home", "Invoices", "View Invoices Details"],
      links: ["home", "Invoices", "viewLink"],
      invoicesID: "",
      invoiceDescription: "",
      invoiceQuantity: "",
      invoicePrice: "",
      totalInvoiceAmt: "",
      alertMessage: "",
      disabled: false,
      show: false,
      clearAttributes: false,
      hideMsg: false,
      msgType: "",
      isLoading: false,
      deatil: "",
      defaultDisabled: "",
    };
  }

  componentWillMount() {
    let invoicesIdParams = this.props.match.params.invoicesId
      ? this.props.match.params.invoicesId
      : "";
    if (invoicesIdParams !== "") {
      this.props.getInvoicesDetails(invoicesIdParams);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.invoicesDetails !== nextProps.invoicesDetails &&
      !isEmpty(nextProps.invoicesDetails)
    ) {
      this.setState({ invoicesDetails: nextProps.invoicesDetails.data });
    }
    if (this.props.error !== nextProps.error) {
      this.setState({
        alertMessage: nextProps.error,
        msgType: "warning",
        show: true,
      });
    }
    if (this.props.fetchInvoices !== nextProps.fetchInvoices) {
      this.setState({ isLoading: nextProps.fetchInvoices });
    }
  }

  componentWillUnmount() {
    this.setState({ alertMessage: "", msgType: "", show: false });
  }

  render() {
    let invoicesData = this.state.invoicesDetails
      ? this.state.invoicesDetails
      : {};
    let invoicesPriceData = invoicesData.child_invoices
      ? invoicesData.child_invoices
      : {};
    let invoicesRow;
    if (invoicesData.child_invoices && invoicesData) {
      invoicesRow = invoicesData.child_invoices.map((invoices, index) => (
        <tr key={invoices.invoicesID}>
          <td className="text-1">
            {invoices.invoiceDescription
              ? invoices.invoiceDescription
              : "Auto Invoices"}
          </td>
          <td className="text-center">
            $
            {invoices.invoicePrice
              ? invoices.invoicePrice
              : invoices.totalInvoiceAmt}
          </td>
          <td className="text-center">
            {invoices.invoiceQuantity ? invoices.invoiceQuantity : 1}
          </td>
          <td className="text-right">
            ${invoices.totalInvoiceAmt ? invoices.totalInvoiceAmt : 0.0}
          </td>
        </tr>
      ));
    }

    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="invoice-container">
          <header>
            <table width="100%">
              <tr>
                <td style={{ textAlign: "center" }}>
                  <img
                    style={{ marginBottom: "10px", height: "75px" }}
                    alt="Invoices"
                    src={siteLogo}
                  />
                </td>
              </tr>
            </table>
          </header>
          <main>
            <table className="table mb-0">
              <tr>
                <td>
                  <strong>Date:</strong>{" "}
                  {invoicesData.invoice_created_date
                    ? moment(invoicesData.invoice_created_date).format(
                        "MM-DD-YYYY"
                      )
                    : ""}
                </td>
                <td style={{ textAlign: "center" }}>
                  <strong>Due Date:</strong>{" "}
                  {invoicesData.daysTillOverdue
                    ? moment(invoicesData.daysTillOverdue).format("MM-DD-YYYY")
                    : ""}
                </td>
                <td className="text-right">
                  {" "}
                  <strong>Invoice No:</strong> 0000{invoicesData.id}
                </td>
              </tr>
            </table>
            <table className="table mb-0">
              <tr>
                <td>
                  <strong>Invoiced To:</strong>
                  <p>
                    {invoicesData.companyName ? invoicesData.companyName : ""},
                    <br />
                    {invoicesData.invoiceAddress1
                      ? invoicesData.invoiceAddress1
                      : ""}
                    ,{" "}
                    {invoicesData.invoiceAddress2
                      ? invoicesData.invoiceAddress2
                      : ""}
                    <br />
                    {invoicesData.invoiceCity ? invoicesData.invoiceCity : ""}
                    <br />
                    {invoicesData.invoiceCountry
                      ? invoicesData.invoiceCountry
                      : ""}
                    <br />
                    {invoicesData.invoiceState ? invoicesData.invoiceState : ""}
                  </p>
                </td>
                <td className="text-right">
                  <strong>Pay To:</strong>
                  <p>
                    Daily Deal Builder
                    <br />
                    82 South Main Street, Unit E<br />
                    Marshall, NC 28753
                    <br />
                    828-319-5333
                    <br />
                    support@hcdesk.com
                  </p>
                </td>
              </tr>
            </table>
            <table className="table mb-0">
              <thead bgcolor="#e4e4e4">
                <tr>
                  <td className="border-0">
                    <strong>Description</strong>
                  </td>
                  <td className="text-center border-0">
                    <strong>Rate</strong>
                  </td>
                  <td className="text-center border-0">
                    <strong>QTY</strong>
                  </td>
                  <td className="text-right border-0">
                    <strong>Amount</strong>
                  </td>
                </tr>
              </thead>
              <tbody>
                {invoicesRow}
                <tr>
                  <td colSpan="3" className="bg-light-2 text-right">
                    <strong>Sub Total:</strong>
                  </td>
                  <td className="bg-light-2 text-right">
                    $
                    {invoicesData.invoiceAmount
                      ? invoicesData.invoiceAmount
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td colSpan="3" className="bg-light-2 text-right">
                    <strong>Total:</strong>
                  </td>
                  <td className="bg-light-2 text-right">
                    $
                    {invoicesData.invoiceAmount
                      ? invoicesData.invoiceAmount
                      : ""}
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="mailWrapper">
              <p>
                To pay by check, please send to the mailing address above{" "}
                <span style={{ color: "#c00" }}>
                  <b>and include c/o Tyler Horne.</b>
                </span>
              </p>
              <p>
                <b>To pay by ACH please send to:</b>
              </p>
              <p>Daily Deal Builder LLC</p>
              <p>
                <span>
                  <b>Routing Number:</b>
                </span>{" "}
                <span>061113415</span>
              </p>
              <p>
                <span>
                  <b>Account Number:</b>
                </span>{" "}
                <span>5248257026</span>
              </p>
            </div>
          </main>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    invoicesDetails: state.invoicesReducers.invoicesDetails,
    error: state.invoicesReducers.error,
    fetchInvoices: state.invoicesReducers.fetchInvoices,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getInvoicesDetails,
  })
)(InvoicesDetails);



// WEBPACK FOOTER //
// ./src/app/views/invoices/InvoicesDetails.js